import React from "react";

import { DataInFreshlyEnteredRow } from "components/PageDashboard/AvailabilitySection/AvailabilityTable/AvailabilityTable";
import { ModalWizardStepRenderProps } from "components/ModalWizard/ModalWizard";
import StepTime from "components/PageDashboard/StepTime";

function StepTimeFrom({
	...rest
}: ModalWizardStepRenderProps<DataInFreshlyEnteredRow>) {
	return (
		<StepTime {...rest} wizardKey={"timeFirstAvailableLocaltime" as any} />
	);
}

export default StepTimeFrom;
